// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* New main menu */
/* Main menu */
.PFS_MainMenu_Wrapper {
  position: sticky;
  background-color: #f4f6f8;
  top: 0;
  z-index: 518;
  box-shadow: inset 0px -1px 0px var(--p-divider);
}

.PFS_MainMenu {
  display: flex;
  justify-content: space-between;
  margin: 0 auto;
  padding: 0 16px;
  max-width: 1200px;
  width: 100%;
}

.PFS_MainMenu>div {
  display: flex;
}

.PFS_MainMenu>div .menuItem .main-item {
  text-align: center;
  color: #6d7175;
  font-size: 14px;
  border: none;
  cursor: pointer;
  display: flex;
  gap: 4px;
  padding: 18px;
}

.menu-actions .badge-ai .Polaris-Badge {
  background: #ffebd3;
  border-radius: 4px;
  padding: 2px 4px;
}

.PFS_MainMenu>div .menuItem.active {
  color: var(--p-action-primary);
  background-color: #edeeef;
  border-bottom: 3px solid var(--p-action-primary);
}

.PFS_MainMenu>div .menuItem.active .main-item {
  color: #008060;
  font-weight: 600;
}

.PFS_MainMenu>div .menuItem.active .main-item .Polaris-Icon svg,
.PFS_MainMenu>div .menuItem.active .main-item .Polaris-Icon path {
  fill: #007f5f;
}

.PFS_MainMenu>div .main-item .Polaris-Badge--statusInfo {
  background-color: #E0F0FF;
  color: #00527C;
  font-weight: 500;
}

.PFS_MainMenu .main-item:hover {
  background-color: #edeeef;
}

.PFS_MainMenu>div .menuItem .main-item .Polaris-Icon {
  width: 20px;
  height: 20px;
}

.PFS_MainMenu>div .menuItem.menu-ai .main-item .Polaris-Icon svg {
  fill: none;
}

.PFS_MainMenu>div .menuItem .main-item .Polaris-Icon svg {
  fill: #5c5f62;
}

.menu-actions {
  padding: 8px;
  min-width: 220px;
}

.menu-actions .group-title {
  display: flex;
  gap: 4px;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  color: #8c9196;
  padding-top: 8px;
}

.menu-actions .group-element {
  padding-left: 20px;
  padding-right: 20px;
  font-size: 14px;
  font-weight: 400;
  line-height: 20px;
  display: flex;
  gap: 4px;
}

.menu-actions .group-title .Polaris-Icon {
  margin: 0;
  width: 16px;
  height: 16px;
}

.menu-actions .group-title .Polaris-Icon svg {
  fill: #8c9196;
  max-width: 16px;
  max-height: 16px;
}

.BC-Warning-TurboBanner {
  background-color: #FFECEC;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 0;
  gap: 8px;
}

.modal-former-upgrade-turbo {
  padding: 16px 20px;
  display: flex;
  flex-direction: column;
  gap: 16px;
}

.modal-former-upgrade-turbo .modal-former-upgrade-turbo__banner {
  background-image: url('https://cdn.boostcommerce.io/assets/campaigns/turbo-campaign-banner.png');
  background-repeat: no-repeat;
  background-size: 100%;
  padding: 24px;
  border-radius: 8px;
}

.modal-former-upgrade-turbo .modal-former-upgrade-turbo__banner__title {
  text-shadow: 0px 5.452px 32.712px rgba(235, 69, 38, 0.40);
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  margin-bottom: 4px;
  color: #fff;
}

.modal-former-upgrade-turbo .modal-former-upgrade-turbo__banner__saving {
  font-weight: 700;
  font-size: 16px;
  line-height: 150%;
  background: linear-gradient(91deg, #C830E1 1.04%, #FE4A25 131.05%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.modal-former-upgrade-turbo .modal-former-upgrade-turbo__banner__saving-semibold {
  font-weight: 600;
  line-height: 150%;
  background: linear-gradient(91deg, #C830E1 1.04%, #FE4A25 131.05%);
  background-clip: text;
  -webkit-background-clip: text;
  -webkit-text-fill-color: transparent;
}

.modal-former-upgrade-turbo .modal-former-upgrade-turbo__banner__advanced-features {
  margin-top: 12px;
  display: flex;
  align-items: center;
}

.modal-former-upgrade-turbo .modal-former-upgrade-turbo__banner__advanced-features .advanced-features__item {
  padding-right: 14px;
  margin-right: 14px;
  border-right: 1px solid rgba(255, 255, 255, 0.2);
  color: #fff;
  display: flex;
  align-items: center;
  column-gap: 6px;
}

.modal-former-upgrade-turbo .modal-former-upgrade-turbo__banner__advanced-features .advanced-features__item:last-child {
  padding-right: 0;
  margin-right: 0;
  border-right: 0;
}

.modal-former-upgrade-turbo .flex-row {
  display: flex;
  align-items: center;
}

.modal-former-upgrade-turbo .why-turbo-box {
  padding: 16px;
  border-radius: 8px;
  background: #FFFBF3;
}

.modal-former-upgrade-turbo .why-turbo-box .why-turbo__list {
  display: flex;
  flex-direction: column;
  gap: 8px;
  padding-left: 0;
  margin-bottom: 0;
}

.modal-former-upgrade-turbo .why-turbo-box .why-turbo__item {
  display: flex;
  align-items: baseline;
  gap: 6px;
}


.modal-former-upgrade-turbo .why-turbo-box .why-turbo__item .Polaris-Icon {
  margin: 0;
  width: 10px;
  height: 10px;
}
.modal-former-upgrade-turbo .why-turbo-box .why-turbo__item .Polaris-Icon__Svg {
  fill: #5C5F62;
}

.modal-former-upgrade-turbo .how-to-upgrade-box {
  padding: 16px;
  border-radius: 8px;
  background: #F7FDFC;
}

.modal-former-upgrade-turbo .how-to-upgrade__list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-left: 18px;
  margin-bottom: 0;
}

.modal-former-upgrade-turbo .how-to-claim-box {
  padding: 16px;
  border-radius: 8px;
  background: #F7FDFC;
}

.modal-former-upgrade-turbo .how-to-claim__list {
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding-left: 18px;
  margin-bottom: 0;
}
`, "",{"version":3,"sources":["webpack://./src/styles/main-menu.css"],"names":[],"mappings":"AAAA,kBAAkB;AAClB,cAAc;AACd;EACE,gBAAgB;EAChB,yBAAyB;EACzB,MAAM;EACN,YAAY;EACZ,+CAA+C;AACjD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,cAAc;EACd,eAAe;EACf,iBAAiB;EACjB,WAAW;AACb;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,kBAAkB;EAClB,cAAc;EACd,eAAe;EACf,YAAY;EACZ,eAAe;EACf,aAAa;EACb,QAAQ;EACR,aAAa;AACf;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,8BAA8B;EAC9B,yBAAyB;EACzB,gDAAgD;AAClD;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;;EAEE,aAAa;AACf;;AAEA;EACE,yBAAyB;EACzB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;AAC3B;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,aAAa;AACf;;AAEA;EACE,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,QAAQ;EACR,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,iBAAiB;EACjB,aAAa;EACb,QAAQ;AACV;;AAEA;EACE,SAAS;EACT,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,QAAQ;AACV;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,gGAAgG;EAChG,4BAA4B;EAC5B,qBAAqB;EACrB,aAAa;EACb,kBAAkB;AACpB;;AAEA;EACE,yDAAyD;EACzD,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kBAAkB;EAClB,WAAW;AACb;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,iBAAiB;EACjB,kEAAkE;EAClE,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,kEAAkE;EAClE,qBAAqB;EACrB,6BAA6B;EAC7B,oCAAoC;AACtC;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gDAAgD;EAChD,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,eAAe;AACjB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,qBAAqB;EACrB,QAAQ;AACV;;;AAGA;EACE,SAAS;EACT,WAAW;EACX,YAAY;AACd;AACA;EACE,aAAa;AACf;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,QAAQ;EACR,kBAAkB;EAClB,gBAAgB;AAClB","sourcesContent":["/* New main menu */\n/* Main menu */\n.PFS_MainMenu_Wrapper {\n  position: sticky;\n  background-color: #f4f6f8;\n  top: 0;\n  z-index: 518;\n  box-shadow: inset 0px -1px 0px var(--p-divider);\n}\n\n.PFS_MainMenu {\n  display: flex;\n  justify-content: space-between;\n  margin: 0 auto;\n  padding: 0 16px;\n  max-width: 1200px;\n  width: 100%;\n}\n\n.PFS_MainMenu>div {\n  display: flex;\n}\n\n.PFS_MainMenu>div .menuItem .main-item {\n  text-align: center;\n  color: #6d7175;\n  font-size: 14px;\n  border: none;\n  cursor: pointer;\n  display: flex;\n  gap: 4px;\n  padding: 18px;\n}\n\n.menu-actions .badge-ai .Polaris-Badge {\n  background: #ffebd3;\n  border-radius: 4px;\n  padding: 2px 4px;\n}\n\n.PFS_MainMenu>div .menuItem.active {\n  color: var(--p-action-primary);\n  background-color: #edeeef;\n  border-bottom: 3px solid var(--p-action-primary);\n}\n\n.PFS_MainMenu>div .menuItem.active .main-item {\n  color: #008060;\n  font-weight: 600;\n}\n\n.PFS_MainMenu>div .menuItem.active .main-item .Polaris-Icon svg,\n.PFS_MainMenu>div .menuItem.active .main-item .Polaris-Icon path {\n  fill: #007f5f;\n}\n\n.PFS_MainMenu>div .main-item .Polaris-Badge--statusInfo {\n  background-color: #E0F0FF;\n  color: #00527C;\n  font-weight: 500;\n}\n\n.PFS_MainMenu .main-item:hover {\n  background-color: #edeeef;\n}\n\n.PFS_MainMenu>div .menuItem .main-item .Polaris-Icon {\n  width: 20px;\n  height: 20px;\n}\n\n.PFS_MainMenu>div .menuItem.menu-ai .main-item .Polaris-Icon svg {\n  fill: none;\n}\n\n.PFS_MainMenu>div .menuItem .main-item .Polaris-Icon svg {\n  fill: #5c5f62;\n}\n\n.menu-actions {\n  padding: 8px;\n  min-width: 220px;\n}\n\n.menu-actions .group-title {\n  display: flex;\n  gap: 4px;\n  align-items: center;\n  font-size: 12px;\n  font-weight: 600;\n  color: #8c9196;\n  padding-top: 8px;\n}\n\n.menu-actions .group-element {\n  padding-left: 20px;\n  padding-right: 20px;\n  font-size: 14px;\n  font-weight: 400;\n  line-height: 20px;\n  display: flex;\n  gap: 4px;\n}\n\n.menu-actions .group-title .Polaris-Icon {\n  margin: 0;\n  width: 16px;\n  height: 16px;\n}\n\n.menu-actions .group-title .Polaris-Icon svg {\n  fill: #8c9196;\n  max-width: 16px;\n  max-height: 16px;\n}\n\n.BC-Warning-TurboBanner {\n  background-color: #FFECEC;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 14px 0;\n  gap: 8px;\n}\n\n.modal-former-upgrade-turbo {\n  padding: 16px 20px;\n  display: flex;\n  flex-direction: column;\n  gap: 16px;\n}\n\n.modal-former-upgrade-turbo .modal-former-upgrade-turbo__banner {\n  background-image: url('https://cdn.boostcommerce.io/assets/campaigns/turbo-campaign-banner.png');\n  background-repeat: no-repeat;\n  background-size: 100%;\n  padding: 24px;\n  border-radius: 8px;\n}\n\n.modal-former-upgrade-turbo .modal-former-upgrade-turbo__banner__title {\n  text-shadow: 0px 5.452px 32.712px rgba(235, 69, 38, 0.40);\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 150%;\n  margin-bottom: 4px;\n  color: #fff;\n}\n\n.modal-former-upgrade-turbo .modal-former-upgrade-turbo__banner__saving {\n  font-weight: 700;\n  font-size: 16px;\n  line-height: 150%;\n  background: linear-gradient(91deg, #C830E1 1.04%, #FE4A25 131.05%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.modal-former-upgrade-turbo .modal-former-upgrade-turbo__banner__saving-semibold {\n  font-weight: 600;\n  line-height: 150%;\n  background: linear-gradient(91deg, #C830E1 1.04%, #FE4A25 131.05%);\n  background-clip: text;\n  -webkit-background-clip: text;\n  -webkit-text-fill-color: transparent;\n}\n\n.modal-former-upgrade-turbo .modal-former-upgrade-turbo__banner__advanced-features {\n  margin-top: 12px;\n  display: flex;\n  align-items: center;\n}\n\n.modal-former-upgrade-turbo .modal-former-upgrade-turbo__banner__advanced-features .advanced-features__item {\n  padding-right: 14px;\n  margin-right: 14px;\n  border-right: 1px solid rgba(255, 255, 255, 0.2);\n  color: #fff;\n  display: flex;\n  align-items: center;\n  column-gap: 6px;\n}\n\n.modal-former-upgrade-turbo .modal-former-upgrade-turbo__banner__advanced-features .advanced-features__item:last-child {\n  padding-right: 0;\n  margin-right: 0;\n  border-right: 0;\n}\n\n.modal-former-upgrade-turbo .flex-row {\n  display: flex;\n  align-items: center;\n}\n\n.modal-former-upgrade-turbo .why-turbo-box {\n  padding: 16px;\n  border-radius: 8px;\n  background: #FFFBF3;\n}\n\n.modal-former-upgrade-turbo .why-turbo-box .why-turbo__list {\n  display: flex;\n  flex-direction: column;\n  gap: 8px;\n  padding-left: 0;\n  margin-bottom: 0;\n}\n\n.modal-former-upgrade-turbo .why-turbo-box .why-turbo__item {\n  display: flex;\n  align-items: baseline;\n  gap: 6px;\n}\n\n\n.modal-former-upgrade-turbo .why-turbo-box .why-turbo__item .Polaris-Icon {\n  margin: 0;\n  width: 10px;\n  height: 10px;\n}\n.modal-former-upgrade-turbo .why-turbo-box .why-turbo__item .Polaris-Icon__Svg {\n  fill: #5C5F62;\n}\n\n.modal-former-upgrade-turbo .how-to-upgrade-box {\n  padding: 16px;\n  border-radius: 8px;\n  background: #F7FDFC;\n}\n\n.modal-former-upgrade-turbo .how-to-upgrade__list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding-left: 18px;\n  margin-bottom: 0;\n}\n\n.modal-former-upgrade-turbo .how-to-claim-box {\n  padding: 16px;\n  border-radius: 8px;\n  background: #F7FDFC;\n}\n\n.modal-former-upgrade-turbo .how-to-claim__list {\n  display: flex;\n  flex-direction: column;\n  gap: 6px;\n  padding-left: 18px;\n  margin-bottom: 0;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
